import { isServerSide } from "@jti/fe-common/utils";
export var XSellingDialogEvents;
(function (XSellingDialogEvents) {
    XSellingDialogEvents["open"] = "xselling-dialog-open";
    XSellingDialogEvents["close"] = "xselling-dialog-close";
})(XSellingDialogEvents || (XSellingDialogEvents = {}));
export const dispatchXSellingDialogEvent = (eventName) => {
    if (isServerSide()) {
        return Promise.resolve();
    }
    const event = new CustomEvent(eventName);
    window.dispatchEvent(event);
    return new Promise((resolve) => setTimeout(resolve, 500));
};
//# sourceMappingURL=dispatchXSellingDialogEvent.js.map